"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

require("./TaskScaleBuilder.css");

var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));

var _Button = _interopRequireDefault(require("react-bootstrap/Button"));

var _CompletedContext = require("../CompletedContext");

var _MusicEditor = _interopRequireDefault(require("./MusicEditor"));

var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));

var _reactBootstrap = require("react-bootstrap");

var TaskScaleBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskScaleBuilder, _React$Component);

  var _super = (0, _createSuper2.default)(TaskScaleBuilder);

  function TaskScaleBuilder(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskScaleBuilder);
    _this = _super.call(this, props);

    _this.submitScale = function () {
      if (_this.props.answers) {
        var found = false;

        var _iterator = (0, _createForOfIteratorHelper2.default)(_this.props.answers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var answer = _step.value;

            if (_this.state.notation === answer.answer) {
              found = true;

              _this.setState({
                completed: answer.correct,
                showAnswer: _this.state.correct !== undefined,
                correct: answer.correct,
                showFeedback: !answer.correct,
                showNag: _this.state.showAnswer,
                feedback: answer.feedback
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (!found) {
          _this.setState({
            completed: false,
            showAnswer: _this.state.correct !== undefined,
            correct: false,
            feedback: _this.props.feedbackIncorrect,
            showFeedback: true,
            showNag: _this.state.showAnswer
          });
        }
      } else {
        if (_this.state.notation === _this.state.correctAnswer) {
          _this.setState({
            showAnswer: _this.state.correct !== undefined,
            correct: true,
            completed: true,
            notation: _this.state.notation,
            showFeedback: false,
            feedback: _this.props.feedbackCorrect
          });
        } else {
          _this.setState({
            showAnswer: _this.state.correct !== undefined,
            correct: false,
            completed: false,
            showFeedback: true,
            showNag: _this.state.showAnswer,
            feedback: _this.props.feedbackIncorrect
          });
        }
      }
    };

    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial || "zzzzzzzz";
    }

    _this.state.precursor = _this.props.musicConfiguration.split(';').join('\n') + '\n';
    _this.state.correctAnswer = _this.props.correct || _this.props.answers.find(function (a) {
      return a.correct;
    }).answer;
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskScaleBuilder, [{
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }

      if (prevprops.musicInitial !== this.props.musicInitial) {
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "zzzzzzzz";
      }

      this.state.precursor = this.props.musicConfiguration.split(';').join('\n') + '\n';
      this.state.correctAnswer = this.props.correct || this.props.answers.find(function (a) {
        return a.correct;
      }).answer;
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$zoom,
          _this3 = this,
          _this$props$zoom2;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-scale-builder"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#f8d7da",
          borderRadius: "5px",
          border: "1px #f5c6cb solid"
        }
      }, "Your Submission:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: !this.state.completed,
        monophonic: true,
        accidentals: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 2,
        precursor: this.state.precursor,
        notation: this.state.notation,
        annotationAltText: this.props.annotationAltText,
        answer: this.state.answer,
        onChange: this.onChange,
        completed: this.state.completed
      })), !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "sb-action-button",
        variant: "dark",
        disabled: this.state.correct,
        style: {
          float: 'left'
        },
        onClick: function onClick() {
          _this3.setState({
            notation: _this3.props.musicInitial,
            reset: true
          });

          _this3.musiceditor.current.setState({
            accidental: ""
          });
        }
      }, " Clear Staff "), /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "sb-action-button",
        variant: "dark",
        disabled: this.state.correct,
        style: {
          float: 'right'
        },
        onClick: this.submitScale
      }, "Submit"))), this.state.showAnswer && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          margin: "10px 0px",
          padding: "10px"
        }
      }, "The correct answer is shown below. Update your answer to match it to move on."), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({}, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: !this.state.completed,
        hideHint: true,
        monophonic: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom2 = this.props.zoom) !== null && _this$props$zoom2 !== void 0 ? _this$props$zoom2 : 2,
        precursor: this.state.precursor,
        notation: this.state.correctAnswer,
        answer: this.state.answer,
        onChange: function onChange() {},
        completed: this.state.completed
      }))), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        correct: this.state.correct,
        show: this.state.showFeedback,
        onHide: function onHide() {
          _this3.setState({
            showFeedback: false
          });
        }
      }, this.state.feedback), this.state.correct && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
        incorrect: !this.state.correct,
        feedback: this.state.feedback
      }));
    }
  }]);
  return TaskScaleBuilder;
}(_react.default.Component);

TaskScaleBuilder.contextType = _CompletedContext.CompletedContext;
var _default = TaskScaleBuilder;
exports.default = _default;